import React from 'react';

export interface SliderProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange?: (value: number) => void;
  tone?: 'primary' | 'secondary' | 'accent';
}

export const Slider = React.forwardRef<HTMLInputElement, SliderProps>(
  (
    {
      value,
      min = 0,
      max = 100,
      step = 1,
      onChange,
      tone = 'primary',
      disabled = false,
      className = '',
      ...props
    },
    ref
  ) => {
    const percentage = Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));

    const toneClasses = {
      primary: 'bg-primary',
      secondary: 'bg-secondary',
      accent: 'bg-accent'
    };

    return (
      <div
        dir="ltr"
        className={`relative flex items-center w-full h-6 select-none touch-none ${className}`}
      >
        <div className="relative w-full h-1.5 bg-base-300 rounded-full overflow-hidden">
          <div
            className={`h-full ${toneClasses[tone]} transition-all duration-75`}
            style={{ width: `${percentage}%` }}
          />
        </div>
        <input
          ref={ref}
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange?.(Number(e.target.value))}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed"
          {...props}
        />
        <div
          className="pointer-events-none absolute size-4.5 bg-white rounded-full shadow-md -translate-x-1/2 border border-base-300"
          style={{ left: `${percentage}%` }}
        />
      </div>
    );
  }
);

Slider.displayName = 'Slider';
